import React from "react";

export const TitleForm = ({ title }) => {
  return (
    <>
      <div className="text-center ">
        <h5>{title}</h5>
      </div>
    </>
  );
};
